import { doc, getDoc } from 'firebase/firestore';
import { LOCATION_ID } from '@/config/location';
import { db } from '@/lib/firebase';
import { COLLECTIONS } from '@/services/firestore/collections';
import { withIdConverter } from '@/services/firestore/converters';
import type { Location } from '@/services/firestore/types';

const locationConverter = withIdConverter<Location>();

export async function getSalonLocation() {
  try {
    const snapshot = await getDoc(
      doc(db, COLLECTIONS.LOCATIONS, LOCATION_ID).withConverter(locationConverter),
    );

    return snapshot.exists() ? snapshot.data() : null;
  } catch (error) {
    console.error('Error fetching salon location:', error);
    throw error;
  }
}
